import axios from "axios";

const API_URL = process.env.REACT_APP_LOGINURL;

const getHeaders = () => ({
  "Content-Type": "application/json",
  token: localStorage.getItem("session-id"),
});

const getAdminNotifications = (limit = 20, offset = 0) => {
  return axios.post(
    `${API_URL}NotificationsModule/GetAdminNotifications`,
    {
      functionName: "GetAdminNotifications",
      postData: { limit, offset },
    },
    { headers: getHeaders() }
  );
};

const getUnreadCount = () => {
  return axios.post(
    `${API_URL}NotificationsModule/UnreadAdminNotificationsCount`,
    {
      functionName: "UnreadAdminNotificationsCount",
      postData: {},
    },
    { headers: getHeaders() }
  );
};

const markAsRead = (id) => {
  return axios.post(
    `${API_URL}NotificationsModule/MarkAdminNotificationRead`,
    {
      functionName: "MarkAdminNotificationRead",
      postData: { id },
    },
    { headers: getHeaders() }
  );
};

const markAllAsRead = () => {
  return axios.post(
    `${API_URL}NotificationsModule/MarkAllAdminNotificationsRead`,
    {
      functionName: "MarkAllAdminNotificationsRead",
      postData: {},
    },
    { headers: getHeaders() }
  );
};

const updateAdminFcmToken = (fcmToken) => {
  return axios.post(
    `${API_URL}NotificationsModule/UpdateAdminFCM`,
    {
      functionName: "UpdateAdminFCM",
      postData: { fcm_token: fcmToken },
    },
    { headers: getHeaders() }
  );
};

const AdminNotificationsService = {
  getAdminNotifications,
  getUnreadCount,
  markAsRead,
  markAllAsRead,
  updateAdminFcmToken,
};

export default AdminNotificationsService;
